<template>
  <div>
    <el-header
      ref="headHeight"
      class="d-flex align-items-center"
      v-if="$store.state.headerShow"
    >
      <span class="headText">
        <div class="menu-nav d-flex align-items-center">
          <div
            ref="menuToggle"
            class="menu-button me-4"
            @click="
              menuHandler($event);
              sidebarSwitch = !sidebarSwitch;
            "
          >
            <span v-if="sidebarSwitch" class="open">
              <i class="el-icon-s-unfold"></i>
            </span>
            <span v-else class="close">
              <i class="el-icon-s-fold"></i>
            </span>
          </div>
          <router-link :to="{ name: 'frontPage' }">
            <img src="../public/img/pics/INNOLUX_116.png" />
          </router-link>
        </div>
      </span>
      <span class="head headText ms-auto">
        <span class="me-4"
          >您好，{{ this.$store.state.loginName }} ，目前線上人數
          {{ this.$store.state.onlineTotal }} 人</span
        >
        <el-button type="primary" size="small" plain @click="logout()"
          >登出</el-button
        >
      </span>
    </el-header>

    <el-container
      v-loading.fullscreen.lock="this.$root.overlay"
      class="sidebox"
      :style="{ paddingTop: $store.state.headerHeight }"
    >
      <el-aside v-show="sidebarSwitch">
        <Sidebar v-if="sidebarSwitch"></Sidebar>
      </el-aside>

      <el-container>
        <el-main>
          <Breadcrumb></Breadcrumb>
          <router-view class="content-body"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<style lang="sass" src="../public/styles/custom.sass"></style>

<script>
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";

export default {
  name: "Waterfall-component",
  components: { Breadcrumb, Sidebar },
  data() {
    return {
      sidebarSwitch: false,
    };
  },
  methods: {
    menuHandler() {
      this.$refs.menuToggle.classList.toggle("active");
    },
    // 登出機制
    logout() {
      this.$confirm("確定要登出嗎？", {
        confirmButtonText: "確定",
        type: "warning",
      })
        .then(async () => {
          this.$message({
            type: "success",
            showClose: true,
            message: "登出成功",
          });
          await this.$store.dispatch("logout");
          localStorage.clear();
          this.$store.state.loginSidebar = [];
          this.$router.replace({ name: "index" });
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>
